import { useEffect } from "react";
import classNames from "classnames";
import {
  RegisterOptions,
  useController,
  useFormContext,
} from "react-hook-form";

import CheckMarkIcon from "assets/icons/banger/check.svg?react";

import "./styles.sass";

export type CheckboxProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  disabled?: boolean;
  name: string;
  mode: "light" | "dark";
  borderNone?: boolean;
  error?: string | null;
  validation?: RegisterOptions;
  label?: string;
  checked?: boolean;
  align?: boolean;
};

const Checkbox = (props: CheckboxProps) => {
  const { control } = useFormContext();
  const {
    name,
    error,
    validation,
    mode = import.meta.env.VITE_APP_PROJECT_NAME === "banger"
      ? "dark"
      : "light",
    label,
    checked,
    borderNone = false,
    align,
  } = props;

  const { field: fieldController } = useController({
    control,
    name,
    rules: validation,
    defaultValue: checked,
  });

  useEffect(() => {
    if (checked && !fieldController.value) {
      fieldController.onChange(checked);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    fieldController.onChange(e.target.checked);
  };

  const handleCheck = () => {
    fieldController.onChange(!fieldController.value);
  };

  const checkboxClass = classNames("Checkbox", {
    align,
  });

  const customCheckbox = classNames("Checkbox__custom", {
    // eslint-disable-next-line camelcase
    Checkbox__custom_error: !!error,
    dark: mode === "dark",
    active: !!fieldController.value,
    borderNone,
  });

  return (
    <div className={checkboxClass}>
      <input
        type="checkbox"
        id={name}
        className="Checkbox__input"
        checked={fieldController.value}
        onChange={handleChange}
      />
      <span className={customCheckbox} onClick={handleCheck}>
        <CheckMarkIcon />
      </span>
      {label && (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label
          className="Checkbox__label"
          htmlFor={name}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: label }}
        />
      )}
    </div>
  );
};

export default Checkbox;
